import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedSvgModule } from '@warema/shared/svg';

@Component({
    selector: 'warema-find-me-btn',
    templateUrl: './find-me-btn.component.html',
    styleUrls: ['./find-me-btn.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedSvgModule, TranslatePipe],
})
export class FindMeBtnComponent {
    public readonly isSearching = input(false);

    public readonly findMe = output<void>();
}
